module.exports = __webpack_public_path__ + "static/media/cab-logo.58288468.png";